import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities, deleteEntity } from 'redux-modules/entity'

import api from 'api'

const CREATE_REQUEST = 'realhub/publicationPackageRule/CREATE_REQUEST'
const CREATE_SUCCESS = 'realhub/publicationPackageRule/CREATE_SUCCESS'
const CREATE_FAILURE = 'realhub/publicationPackageRule/CREATE_FAILURE'
const DELETE_REQUEST = 'realhub/publicationPackageRule/DELETE_REQUEST'
const DELETE_SUCCESS = 'realhub/publicationPackageRule/DELETE_SUCCESS'
const DELETE_FAILURE = 'realhub/publicationPackageRule/DELETE_FAILURE'

// Initial State
const initialState = {
  loaded: false,
  loadedIds: [],
  loading: false,
  creating: false,
  updating: false,
  errors: [],
}

// Actions
export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function deleteRequest(){
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess(){
  return {
    type: DELETE_SUCCESS,
  }
}

export function deleteFailure(errors = []){
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function createPublicationPackageRule(publicationPackageRule, options, callback){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      publication_package_rule: publicationPackageRule,
    }),
  }

  return (dispatch) => {
    // Set Loading
    dispatch(createRequest())

    const { publication_package_id } = publicationPackageRule
    const promise = api(`/admin/publication_packages/${publication_package_id}/rules.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.PUBLICATION_PACKAGE_RULE)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        if (callback) callback(json)
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(createFailure(errors))
      })

    return promise
  }
}

export function deletePublicationPackageRule(publicationPackageRule, options, callback){
  const config = {
    method: 'DELETE',
  }

  return (dispatch) => {
    // Set Loading
    dispatch(deleteRequest())

    const { id, publication_package_id } = publicationPackageRule
    const promise = api(`/admin/publication_packages/${publication_package_id}/rules/${id}.json`, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.PUBLICATION_PACKAGE_RULE)
        dispatch(deleteEntity(normalizedJson))
        dispatch(deleteSuccess())

        if (callback) callback(json)
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(deleteFailure(errors))
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case CREATE_REQUEST:
      return Object.assign({}, state, {
        creating: true,
      })
    case CREATE_SUCCESS:
      return Object.assign({}, state, {
        creating: false,
        errors: [],
      })
    case CREATE_FAILURE:
      return Object.assign({}, state, {
        creating: false,
        errors: action.errors,
      })
    case DELETE_REQUEST:
      return Object.assign({}, state, {
        updating: true,
      })
    case DELETE_SUCCESS:
      return Object.assign({}, state, {
        updating: false,
      })
    case DELETE_FAILURE:
      return Object.assign({}, state, {
        updating: false,
      })
    default:
      return state
  }
}
